import React from 'react';
interface Row {
  problem: string;
  remedies: string[];
  wires: string[];
}
const rows: Row[] = [{
  problem: 'To Reduce Wire Breakage.',
  remedies: ['Use larger diameter wire.', 'Decrease tension during roughing.', 'Use "soft" servos.', 'Increase tensile strength.', 'Increase fracture toughness.'],
  wires: ['Al or Mg brass alloy.', 'Coated steel core.']
}, {
  problem: 'To Increase Cutting Speed.',
  remedies: ['Use larger diameter wire.', 'Increase power.', 'Increase electrode conductivity.', 'Better flushing.'],
  wires: ['Zinc coated copper.', 'Zinc coated brass.']
}, {
  problem: 'To Cut Steep Tapers.',
  remedies: ['Increase ductility.'],
  wires: ['Soft brass.', 'Zinc coated soft brass.', 'Diffusion annealed brass.']
}, {
  problem: 'To Cut Thicker Workpieces.',
  remedies: ['Use larger diameter wire.', 'Increase power.', 'Increase electrode conductivity', 'Better flushing.', 'Increase tensile strength.'],
  wires: ['Diffusion annealed copper.', 'Diffusion annealed brass.', 'Coated steel core.']
}, {
  problem: 'To Increase Straightness.',
  remedies: ['Increase tensile strength.'],
  wires: ['Al or Mg brass alloy.', 'Moly or tungsten wire.', 'Coated steel core.']
}, {
  problem: 'To Increase Accuracy.',
  remedies: ['Increase tensile strength.', 'Increase fracture toughness.'],
  wires: ['Al or Mg/brass alloy.', 'Coated steel core.']
}];
export function TroubleshootingSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-4449">
      <h2 className="text-2xl font-bold text-[#026ab7] mb-6" data-id="element-4450">
        General guidelines for EDM wire selection and troubleshooting*
      </h2>

      <div className="overflow-x-auto" data-id="element-4451">
        <table className="w-full text-left border-collapse" data-id="element-4452">
          <thead data-id="element-4453">
            <tr className="border-b-2 border-gray-300" data-id="element-4454">
              <th className="py-4 pr-6 font-bold text-gray-900" data-id="element-4455">Problem</th>
              <th className="py-4 pr-6 font-bold text-gray-900" data-id="element-4456">Remedy*</th>
              <th className="py-4 font-bold text-gray-900" data-id="element-4457">Wire</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 text-gray-700" data-id="element-4458">
            {rows.map(row => <tr key={row.problem} data-id="element-4459">
                <td className="py-4 pr-6 font-medium align-top" data-id="element-4460">
                  {row.problem}
                </td>
                <td className="py-4 pr-6 align-top" data-id="element-4461">
                  <ul className="list-disc list-inside space-y-1" data-id="element-4462">
                    {row.remedies.map((r, i) => <li key={i} data-id="element-4463">{r}</li>)}
                  </ul>
                </td>
                <td className="py-4 align-top" data-id="element-4464">
                  <ul className="list-disc list-inside space-y-1" data-id="element-4465">
                    {row.wires.map((w, i) => <li key={i} data-id="element-4466">{w}</li>)}
                  </ul>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="mt-6 text-sm text-gray-500 italic space-y-2" data-id="element-4467">
        <p data-id="element-4468">
          *Actual adjustments of current, servo speeds, flushing pressure, etc.,
          are not noted here but may be necessary to realize the full potential
          of the troubleshooting process.
        </p>
        <p data-id="element-4469">E. Bud Guitrau, F.I.A.E.</p>
      </div>
    </div>;
}